<div class="fdx-u-mt--2 fdx-u-mb--2 float-left col-10" style="margin-left:-15px" [hidden]="lockComponent_Hide">
    <div class="fdx-c-modal__description text-left" style="font-weight:bold;font-size:1.2rem;" [innerHTML]="lockComponentTitleContent">
    </div>
    <div *ngFor="let item of lockComponentListContent.controls; let i = index" [formGroup]="item">
        <div class="fdx-o-grid__row fdx-o-grid__row--guttered-small">
            <div
                class="fdx-o-grid__item fdx-o-grid__item--12 fdx-o-grid__row--guttered-small fdx-c-form-group">
                <!-- <input type="checkbox" [id]="item.get('lockCode').value" class="fdx-c-form-group__checkbox"
                    [checked]="true" [disabled]="true" /> -->
                <label class="fdx-c-form-group__label" style="font-weight:400;font-size:1rem" [for]="item.get('lockCode').value">
                    {{ item.get('lockCodeDesc').value }}
                </label>
            </div>
        </div>
    </div>
</div>